<template>
  <fieldset class="form__fieldset">
    <FormInput :label="$beet.options.form.labels.email" name="email" type="email" v-model="form.fields.email" />
    <div class="form__checkbox-group">
      <FormCheckbox :options="jobTypeOptions" name="job_type" :label="$beet.options.form.labels.field"
        v-model="form.fields.job_types" :required="true" />
      <FormCheckbox :options="locationOptions" name="location" :label="$beet.options.form.labels.location"
        v-model="form.fields.locations" :required="true" />
    </div>
  </fieldset>
</template>

<script>
import { FormCheckbox, FormInput } from '@/components/form/fields'
import { formatFormOptions } from '@/components/form/helpers'

export default {
  name: 'JobAlertForm',
  components: { FormCheckbox, FormInput },
  data() {
    return {
      form: {
        fields: {
          email: { value: null, valid: false },
          job_types: { value: [], valid: false },
          locations: { value: [], valid: false },
        },
        received: false,
        server__error: null,
        submitted: false,
        valid: false,
      }
    }
  },
  watch: {
    'form': {
      handler() {
        this.form.valid = !Object.values(this.form.fields).some(({ valid }) => valid === false)
      },
      deep: true
    },
    'form.fields': {
      handler() {
        this.$emit('update:modelValue', this.form)
      },
      deep: true
    }
  },
  computed: {
    jobTypeOptions() {
      return formatFormOptions(this.$store.state.job.types)
    },
    locationOptions() {
      return formatFormOptions(this.$store.state.job.locations)
    }
  }
}
</script>